import React from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Loading } from '../../shared/components';
import { Snackbar } from '@material-ui/core';
import { isMobile } from 'is-mobile';
import { Modal, Button } from 'react-bootstrap';
import images from '@assets';
import OnboardingSidebar from './OnboardingSidebar';
import onboardingStore from '../../stores/onboardingStore';
import OnboardingService from '../../services/onboarding.service';
import './OnboardingLayout.scss';

@inject('commonStore')
@withRouter
@observer
export default class OnboardingLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobileScreen: window.innerWidth < 480,
            showExitConfirmation: false
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const newIsMobileScreen = window.innerWidth < 480;
        if (newIsMobileScreen !== this.state.isMobileScreen) {
            this.setState({
                isMobileScreen: newIsMobileScreen,
            });
        }
    };

    toggleNav = e => {
        e.preventDefault();
        let { commonStore } = this.props;
        commonStore.setNavMini(!commonStore.navMini);
    };

    hideNav = e => {
        e.stopPropagation();
        e.preventDefault();
        let { commonStore } = this.props;
        commonStore.setNavMini(false);
    };

    close = () => {
        this.props.commonStore.open = false;
    };

    navigateHome = () => {
        // Show confirmation dialog before leaving onboarding
        this.setState({ showExitConfirmation: true });
    };

    handleCancelExit = () => {
        this.setState({ showExitConfirmation: false });
    };

    handleConfirmExit = async () => {
        const { commonStore, history } = this.props;

        try {
            // Close the modal first
            this.setState({ showExitConfirmation: false });

            // Show loading
            commonStore.setLoading(true);

            // Get all saved onboarding data (completed steps only)
            const onboardingData = onboardingStore.getOnboardingData();

            const profileId = commonStore.businessProfile?.id;

            // Complete onboarding with whatever data has been saved
            const result = await OnboardingService.completeOnboarding(onboardingData, profileId);

            if (result.success) {
                // Update business profile if needed
                if (result.profileId && !profileId) {
                    await commonStore.getBusinessProfile(result.profileId);
                }

                // Clear onboarding data from storage
                onboardingStore.clearOnCompletion();

                // Show success message
                commonStore.setMsg('Your progress has been saved. You can continue onboarding anytime.');

                // Navigate to home
                history.push('/home');
            }
        } catch (error) {
            console.error('Error completing onboarding:', error);

            // Even if there's an error, allow navigation (non-blocking)
            commonStore.setMsg('Your progress has been saved locally.');

            // Navigate to home anyway
            history.push('/home');
        } finally {
            commonStore.setLoading(false);
        }
    };

    render() {
        const { commonStore, currentStep = 1, totalSteps = 3 } = this.props;
        const { navMini, open, msg } = commonStore;
        const { showExitConfirmation } = this.state;
        const progressPercentage = (currentStep / totalSteps) * 100;

        return (
            <div className='app-wrapper onboarding-layout'>
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={open}
                    autoHideDuration={5000}
                    message={msg}
                    onClose={this.close}
                />
                <Loading />
                <OnboardingSidebar mini={navMini} />
                <div
                    className={`content-container ${navMini ? 'full' : ''} ${
                        isMobile() ? 'mobile' : ''
                    }`}
                >
                    {/* dropshadow for mobile nav triggering */}
                    <div
                        className='menu-dropshadow'
                        style={{ display: navMini ? 'block' : 'none' }}
                        onClick={this.hideNav}
                    ></div>

                    {/* Top Navigation Bar */}
                    <header className="onboarding-header-nav">
                        <div className="header-left">
                            <img
                                src={images.menu_white}
                                alt='menu'
                                onClick={this.toggleNav}
                                className="menu-icon"
                            />
                        </div>
                        <div className="header-right">
                            <button
                                className="home-button"
                                onClick={this.navigateHome}
                            >
                                Home
                            </button>
                        </div>
                    </header>

                    {/* Main Content Area */}
                    <div className="onboarding-main-content">
                        <div className="onboarding-content-wrapper">
                            {/* Header */}
                            <div className="onboarding-page-header">
                                <h2 className="onboarding-brand">Fast Apply with NisaAI</h2>
                                <p className="onboarding-subtitle">Apply in a few easy steps with Nisa AI</p>
                            </div>

                            {/* Progress Bar */}
                            <div className="progress-container">
                                <div className="progress-bar">
                                    <div
                                        className="progress-fill"
                                        style={{ width: `${progressPercentage}%` }}
                                    ></div>
                                </div>
                                <div className="progress-text">
                                    Step {currentStep} of {totalSteps}
                                </div>
                            </div>

                            {/* Step Content */}
                            <div className="step-content-area">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Exit Confirmation Modal */}
                <Modal show={showExitConfirmation} onHide={this.handleCancelExit} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Exit Onboarding?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Are you sure you want to exit onboarding? Your progress will be saved.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCancelExit}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.handleConfirmExit}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
